import { render, staticRenderFns } from "./InformList.vue?vue&type=template&id=6214610a&scoped=true"
import script from "./InformList.vue?vue&type=script&lang=js"
export * from "./InformList.vue?vue&type=script&lang=js"
import style0 from "./InformList.vue?vue&type=style&index=0&id=6214610a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214610a",
  null
  
)

export default component.exports